import { render, staticRenderFns } from "./Rwlist.vue?vue&type=template&id=644cdf3a&scoped=true"
import script from "./Rwlist.vue?vue&type=script&lang=js"
export * from "./Rwlist.vue?vue&type=script&lang=js"
import style0 from "./Rwlist.vue?vue&type=style&index=0&id=644cdf3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644cdf3a",
  null
  
)

export default component.exports